export const searchTypes = {
  SEARCH_BAR_OFFER: 'offer',
  SEARCH_BAR_COMPANY: 'company',
}
